import React, {ChangeEvent, ReactNode, createRef} from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {requireImage} from '../../utils/utils';

import './styles.scss';

interface ImageLoaderProps {
    imageModel?: string;
    onImageSelect: (imageFile: string) => void;
    onFailedLoad: (err: any) => void;
    useNewInterface?: boolean;
}

@observer
export class ImageLoader extends TechseeBaseComponent<ImageLoaderProps> {
    private fileInputRef = createRef<HTMLInputElement>();

    constructor(props: ImageLoaderProps) {
        super(props);
    }

    private getImageURL = (imageFile: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e: ProgressEvent<FileReader>) => {
                const dataUrl = e.target?.result as string;
                resolve(dataUrl);
            };

            reader.onerror = (e) => {
                reject(e);
            };

            reader.readAsDataURL(imageFile);
        });
    };

    private upload = async (file: File | null): Promise<void> => {
        if (!file) {
            return;
        }

        // Validate image file type
        if (!/^image\//.test(file.type)) {
            const error = {
                fileTypeError: true,
                details: {
                    type: file.type,
                    size: file.size
                }
            };

            if (this.props.onFailedLoad) {
                this.props.onFailedLoad(error);
            } else if (this.props.onImageSelect) {
                this.props.onImageSelect('');
            }
            return;
        }

        try {
            // Convert to data URL instead of blob URL
            const imageUrl = await this.getImageURL(file);

            this.props.onImageSelect(imageUrl);
        } catch (err) {
            if (this.props.onFailedLoad) {
                this.props.onFailedLoad(err);
            }
        }
    };

    private handleFileChange = (event: ChangeEvent<HTMLInputElement>): void => {
        const file = event.target.files?.[0] || null;
        this.upload(file);
        event.target.value = '';
    };

    private handleClick = (e?: React.MouseEvent<HTMLDivElement>): void => {
        e?.stopPropagation();
    };

    renderInternal(): JSX.Element {
        const {useNewInterface = false} = this.props;

        return (
            <div className={'dashboard-library-loader btn btn-primary'} onClick={this.handleClick}>
                <input
                    id='image-upload-input'
                    ref={this.fileInputRef}
                    type='file'
                    accept='image/*'
                    onChange={this.handleFileChange}
                    className='ts-image-loader'
                    style={{display: 'none'}}
                />
                <label htmlFor='image-upload-input' className='ts-image-loader-button'>
                    <>
                        {!useNewInterface && <span className='glyphicon glyphicon-plus'></span>}
                        {useNewInterface && (
                            <img
                                className='side-bar-icon'
                                src={requireImage('upload-image.png', useNewInterface)}
                                alt='Upload'
                            />
                        )}
                    </>
                </label>
            </div>
        );
    }
}
